class CollapsableInVivoSpf extends HTMLElement {
  connectedCallback() {
    this._preview = this.querySelector('[data-vivo-preview]');
    this._modal = this.querySelector('[data-vivo-modal]');
    this._modalImg = this.querySelector('[data-vivo-modal-img]');
    this._closeBtn = this.querySelector('[data-vivo-modal-close]');

    if (!this._preview || !this._modal || !this._modalImg) return;

    this._onPreviewClick = this._onPreviewClick.bind(this);
    this._onModalClick = this._onModalClick.bind(this);
    this._onCloseBtnClick = this._onCloseBtnClick.bind(this);

    this._preview.addEventListener('click', this._onPreviewClick);
    this._modal.addEventListener('click', this._onModalClick);
    this._closeBtn?.addEventListener('click', this._onCloseBtnClick);
  }

  disconnectedCallback() {
    this._preview?.removeEventListener('click', this._onPreviewClick);
    this._modal?.removeEventListener('click', this._onModalClick);
    this._closeBtn?.removeEventListener('click', this._onCloseBtnClick);
  }

  _onPreviewClick() {
    const { fullSrc } = this._preview.dataset;
    if (!fullSrc) return;
    this._modalImg.src = fullSrc;
    this._modal.classList.add('is-open');
  }

  _onModalClick(e) {
    if (e.target === this._modal) {
      this._modal.classList.remove('is-open');
    }
  }

  _onCloseBtnClick() {
    this._modal.classList.remove('is-open');
  }
}

customElements.define('collapsable-in-vivo-spf', CollapsableInVivoSpf);
